var RecruitController = function() {
    this.SingleImgAdjust = require('../module/SingleImgAdjust');
    this.init();
};

RecruitController.prototype = {
    init: function() {
        var singleImgAdjust = new this.SingleImgAdjust();
        singleImgAdjust.init();

        var $itemsA = $('#js-list-recruit-a').find('.list-item');
        var $itemsB = $('#js-list-recruit-b').find('.list-item');
        var itemHeihgt = [];

        $itemsA.each(function(i) {
            var $this = $(this);
            itemHeihgt.push($this.outerHeight());
            if (i%2 !== 0) {
                $this.css({
                    height: Math.max.apply(null, itemHeihgt)
                });
                $this.find('.list-item-button').css({
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    width: '100%'
                });
                $itemsA.eq(i-1).css({
                    height: Math.max.apply(null, itemHeihgt)
                });
                $itemsA.eq(i-1).find('.list-item-button').css({
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    width: '100%'
                });
                itemHeihgt = [];
            }
        });

        itemHeihgt = [];
        $itemsB.each(function(i) {
            var $this = $(this);
            itemHeihgt.push($this.outerHeight());
            if (i%2 !== 0) {
                $this.css({
                    height: Math.max.apply(null, itemHeihgt)
                });

                $itemsB.eq(i-1).css({
                    height: Math.max.apply(null, itemHeihgt)
                });

                itemHeihgt = [];
            }
        });

    }
};

module.exports = RecruitController;


/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/pc/assets/js/controller/RecruitController.js
 **/